import { render, staticRenderFns } from "./MyDetails.vue?vue&type=template&id=f5d68e56&scoped=true"
import script from "./MyDetails.vue?vue&type=script&lang=js"
export * from "./MyDetails.vue?vue&type=script&lang=js"
import style0 from "./MyDetails.vue?vue&type=style&index=0&id=f5d68e56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d68e56",
  null
  
)

export default component.exports